import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { CurrenciesService, PerfectMoneyService } from "@/services";
const NumberInput = () => import("@/components/NumberInput/index");
const OtpVerify = () => import("@/components/Shared/OtpVerify/index");
import $thousandMask from "@/mixins/thousandMask";
import dropRightWhile from "lodash-es/dropRightWhile";
const Captcha = () =>
  import(/* webpackChunkName: "Captcha" */ "@/components/Captcha/index");
export default {
  name: "sell",
  components: { NumberInput, Captcha, OtpVerify },
  props: [],
  mixins: [$thousandMask],
  data() {
    return {
      convertBtn: true,
      fromCurrency: {},
      fromValue: "",
      toCurrency: {},
      toValue: "",
      lastValidToValue: "",
      toExchanges: [],
      toValueRules: "",
      fromValueRules: "",
      isUpdating: false,
      balance: "",
      isSourceAmountFix: true,
      loading: false,
      perfectAddress: "",
      captcha_token: null,
      captcha_value: null,
      captcha_hash: null,
      reloadCaptcha: false,
      ev_number: null,
      ev_code: null,
      publicUrl: process.env.VUE_APP_PUBLIC_BASE_URL,
      channelLabel: []
    };
  },
  computed: {
    ...mapGetters({
      getCurrencies: types.currencies.getters.GET_CURRENCIES,
      getWallets: types.operations.getters.GET_WALLET,
      exchanges: types.wallets.getters.GET_EXCHANGE_WALLETS
    }),
    getFiatCurrency() {
      if (Object.entries(this.getCurrencies).length > 0) {
        return this.getCurrencies.find(elem => {
          if (elem.iso === this.$route.query.from) {
            console.log(elem);
            return elem;
          }
        });
      }
    },
    filterExchanges() {
      let list = [];
      if (
        Object.entries(this.getCurrencies).length > 0 &&
        Object.entries(this.getFiatCurrency).length > 0
      ) {
        this.getFiatCurrency.exchanges.forEach(elem => {
          if (elem.normal_balance) {
            this.getCurrencies.find(item => {
              if (item.iso === elem.to) {
                list.push(item);
              }
            });
          }
        });
        return list;
      }
    },
    pureFromValue() {
      return this.removeThousand(this.fromValue);
    },
    pureToValue() {
      return this.removeThousand(this.toValue);
    }
  },
  mounted() {
    CurrenciesService.getCurrencies().then(async response => {
      response.data.data.find(element => {
        if (element.iso === this.$route.query.from) {
          this.fromCurrency = element;
        }
      });
      this.currenciesDataAction(response.data.data);
      let data = [];
      response.data.data.forEach(elem => {
        if (elem.iso === this.$route.query.from) {
          elem.exchanges.find(item => {
            if (item.normal_balance) {
              response.data.data.find(element => {
                if (element.iso === item.to) {
                  data.push(element);
                }
              });
            }
          });
        }
      });
      this.toCurrency = data[0];
    });
  },
  methods: {
    ...mapActions({
      currenciesDataAction: types.currencies.actions.SET_CURRENCIES
    }),
    channelLabelFunc(data) {
      this.channelLabel = data;
    },
    captchaChanged(captchaData) {
      this.captcha_token = captchaData.token;
      this.captcha_value = captchaData.value;
    },
    changeUrlPage() {
      this.$router.push({ name: "fiat" });
    },
    calculateExchange(from, to, fromValue, toValue) {
      let fromPrice = 0;
      let toPrice = 0;
      /* USER WANTS TO BUY */
      if (from?.iso === "IRR") {
        fromPrice = from?.price; /* we get user Rial */
        toPrice = to.buy_price; /* we sell crypto */

        /* USER WANTS TO SELL */
      } else if (to?.iso === "IRR") {
        fromPrice = from.sell_price; /* we buy user crypto */
        toPrice = to?.price; /* we pay Rial */

        /* USER WANTS TO CHANGE */
      } else {
        fromPrice = from?.price; /* we buy user crypto */
        toPrice = parseFloat(
          to?.change_price_denormalized_string
        ); /* we change crypto */
      }
      /* returns toValue */
      if (fromValue) {
        const result = (fromValue * fromPrice) / toPrice;
        return this.exponent(this.toCurrency, result);

        /* returns fromValue */
      } else if (toValue) {
        const result = (toValue * toPrice) / fromPrice;
        return this.exponent(this.fromCurrency, result);
      }
    },
    getResult(destination) {
      if (this.fromCurrency && this.toCurrency) {
        if (destination === "to") {
          return this.calculateExchange(
            this.fromCurrency,
            this.toCurrency,
            this.removeThousand(this.fromValue),
            0
          );
        } else if (destination === "from") {
          return this.calculateExchange(
            this.fromCurrency,
            this.toCurrency,
            0,
            this.removeThousand(this.toValue)
          );
        }
      }
    },
    updateToCurrency(newCurrency) {
      this.toCurrency = newCurrency;
      this.fromValue = "";
      this.toValue = "";
      // const result = this.getResult("to");
      // this.toValue = this.$thousandMask(result);
      this.showToValueRules(this.toValue);
      // const result = this.getResult("to");
      // this.toValue = this.$thousandMask(result);
      // this.showToValueRules(this.toValue, this.fromValue);
    },
    updateFromValue({ target: { value } }) {
      const set = amount => {
        const enDigit = this.toEnglishDigits(amount);
        const noComma = this.removeThousand(enDigit);
        const zeroChecked = this.leadingZero(noComma);
        const expo = this.exponent(this.fromCurrency, zeroChecked);
        const isPositiveNumbers = str => {
          const reg = new RegExp(/^([0-9,.۰-۹٫])*$/);
          return reg.test(str);
        };
        const withoutDot = expo.replace(".", "");
        if (isPositiveNumbers(withoutDot)) {
          const result = this.calculateExchange(
            this.fromCurrency,
            this.toCurrency,
            expo,
            0
          );
          this.toValue = result ? this.$thousandMask(result) : "";
          this.fromValue = this.$thousandMask(noComma);
          this.showToValueRules(result);
        }
      };
      set(value);
      this.isSourceAmountFix = true;
    },
    updateToValue({ target: { value } }) {
      const set = amount => {
        const enDigit = this.toEnglishDigits(amount);
        const noComma = this.removeThousand(enDigit);
        const zeroChecked = this.leadingZero(noComma);
        const expo = this.exponent(this.toCurrency, zeroChecked);
        const isPositiveNumbers = str => {
          const reg = new RegExp(/^([0-9,.۰-۹٫])*$/);
          return reg.test(str);
        };
        const withoutDot = expo.replace(".", "");
        if (isPositiveNumbers(withoutDot)) {
          const result = this.calculateExchange(
            this.fromCurrency,
            this.toCurrency,
            0,
            expo
          );
          this.fromValue = result ? this.$thousandMask(result) : "";
          this.toValue = this.$thousandMask(noComma);
          this.showToValueRules(noComma);
        }
      };
      set(value);
      this.isSourceAmountFix = false;
    },
    sellFiats() {
      this.loading = true;
      let data = {
        from_currency_id: this.fromCurrency.id,
        from_amount: this.fromValue
          ? this.removeThousand(this.fromValue)
          : this.fromValue,
        to_currency_id: this.toCurrency.id,
        to_amount: this.toValue
          ? this.removeThousand(this.toValue)
          : this.toValue,
        captcha_token: this.captcha_token,
        captcha_value: this.captcha_value,
        ev_code: this.ev_code,
        ev_number: this.ev_number
      };
      PerfectMoneyService.sellFiats(data)
        .then(response => {
          this.$router.push({
            path: `/submit-order/${response.data.data.ref_no}/fiats/sell`
          });
        })
        .catch(error => {
          this.captcha_token = null;
          this.captcha_value = null;
          this.captcha_hash = error.data.captcha_hash;
        })
        .finally(() => {
          this.loading = false;
          this.reloadCaptcha = !this.reloadCaptcha;
        });
    },
    showToValueRules(to) {
      let currency = this.fromCurrency.exchanges?.find(
        currency => currency.to === this.toCurrency?.iso
      );
      if (parseFloat(to) > parseFloat(currency.maximum_amount_to)) {
        this.fromValueRules = "";
        this.toValueRules = this.$tc(
          "operationsPage.exchange.maxReceive",
          `${this.$thousandMask(this.toCurrency?.iso)} ${
            currency.maximum_amount_to
          }`
        );
      } else if (parseFloat(to) < parseFloat(currency.minimum_amount_to)) {
        this.fromValueRules = "";
        this.toValueRules = this.$tc(
          "operationsPage.exchange.minReceive",
          `${this.$thousandMask(this.toCurrency?.iso)} ${
            currency.minimum_amount_to
          }`
        );
      } else {
        this.toValueRules = "";
        this.fromValueRules = "";
      }
      // return value === "min" ? this.$thousandMask(currency.minimum_amount_to) : value === "max" && this.$thousandMask(currency.maximum_amount_to);
    },
    exponent(currency, value) {
      const isNegative = number => {
        return number < 0;
      };

      const isInt = number => {
        return !number.includes(".");
      };

      const decimalsLength = float => {
        const arr = (float + "").split(".");
        return arr[1]?.length;
      };
      if (isNegative(value)) {
        return "";
      } else if (isInt(value.toString())) {
        return value;
      } else if (!isInt(value.toString())) {
        const { exponent } = currency;
        if (decimalsLength(value) <= exponent) {
          const str = value.toString();
          const spl = str?.split(".");
          const decimals = spl[1];
          const decimalsSplit = decimals?.split("");
          const dropped = dropRightWhile(
            decimalsSplit,
            number => number === "0"
          );
          return dropped?.length ? spl[0] + "." + dropped.join("") : spl[0];
        } else {
          /* remove  zeros in decimals 1.20000*/
          const float = parseFloat(value);
          const fixed = float?.toFixed(exponent);
          const spl = fixed?.split(".");
          const decimals = spl[1];
          const decimalsSplit = decimals?.split("");
          const dropped = dropRightWhile(
            decimalsSplit,
            number => number === "0"
          );
          /* if no decimals => remove . */
          return dropped?.length ? spl[0] + "." + dropped.join("") : spl[0];
        }
      }
    },
    toEnglishDigits(value) {
      const persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return value
        .toString()
        .replace("٫", ".")
        .replace(/[۰-۹]/g, chr => {
          return persian.indexOf(chr);
        });
    },
    removeThousand(str) {
      return str.toString().replace(/,/gi, "");
    },
    leadingZero(value) {
      let number = value.toString();
      if (value.includes(".")) {
        while (number.charAt(0) === "0" && number.charAt(1) !== ".") {
          number = number.substring(1);
        }
      } else if (number.slice(-1) !== "0") {
        while (number.charAt(0) === "0") {
          number = number.substring(1);
        }
      }
      return number;
    }
  },
  watch: {
    fromValue(newValue, oldValue) {
      if (newValue) {
        let { exponent } = this.fromCurrency;
        let numberLength = newValue.toString().split(".")[1]
          ? newValue.toString().split(".")[1].length
          : 0;
        const isPositiveNumbers = str => {
          const reg = new RegExp(/^([0-9,.۰-۹٫])*$/);
          return reg.test(str);
        };
        const withoutDot = newValue.replace(".", "");
        if (numberLength && numberLength > exponent) {
          this.fromValue = oldValue;
        } else if (exponent === 0 && newValue.includes(".")) {
          this.fromValue = oldValue.replace(".", "");
        }
        if (newValue[0] === "0") {
          if (newValue[1] && newValue[1] !== ".") {
            this.fromValue = "";
            this.toValue = "";
          }
        } else if (withoutDot.includes(".")) {
          this.fromValue = oldValue;
        } else if (!isPositiveNumbers(newValue)) {
          this.fromValue = oldValue;
        }
      }
    },
    toValue(newValue, oldValue) {
      if (newValue) {
        let { exponent } = this.toCurrency;
        let numberLength = newValue.toString().split(".")[1]
          ? newValue.toString().split(".")[1].length
          : 0;
        const isPositiveNumbers = str => {
          const reg = new RegExp(/^([0-9,.۰-۹٫])*$/);
          return reg.test(str);
        };
        if (numberLength && numberLength > exponent) {
          this.toValue = oldValue;
        } else if (exponent === 0 && newValue.includes(".")) {
          this.toValue = oldValue.replace(".", "");
        }
        if (newValue[0] === "0") {
          if (newValue[1] && newValue[1] !== ".") {
            this.fromValue = "";
            this.toValue = "";
          }
        } else if (!isPositiveNumbers(newValue)) {
          this.toValue = oldValue;
        }
      }
    }
  }
};
